import React from "react";
import { QueryStatus } from "@sscs/types";
import { DataTable, DataTableColumn } from "@sscs/ui";
import { PersonalAccessTokenInfo } from "Types";
import TokenTableRow from "../TokenTableRow/TokenTableRow";

const COLUMNS: DataTableColumn[] = [
  { id: "name", label: "Token name", width: "100%", align: "left" },
  { id: "lastUsed", label: "Last used", width: "200px", align: "left" },
  { id: "expiration", label: "Expiration date", width: "200px", align: "left" },
  { id: "actions", label: "", width: "140px", align: "center" },
];

type TokenTableProps = {
  tokens: PersonalAccessTokenInfo[];
  status: QueryStatus;
};

const TokenTable = ({ tokens, status }: TokenTableProps): React.JSX.Element => {
  return (
    <DataTable
      chrome="plain"
      title="Tokens"
      columns={COLUMNS}
      empty={{ subject: "tokens" }}
      status={status}
    >
      {tokens.map((token) => (
        <TokenTableRow key={token.digest} token={token} />
      ))}
    </DataTable>
  );
};

export default TokenTable;
